// src/pages/UserPages/MainPage.js

import React from "react";
import { ThemeModeProvider } from "../../components/ThemeModeContext"; // Importando o ThemeModeProvider
import ThemeProviderWrapper from "../../components/ThemeProviderWrapper"; // Importando o ThemeProviderWrapper
import UserMainPageContent from "./UserMainPageContent"; // Importando o conteúdo separado

function UserMainPage() {
  return (
    <ThemeModeProvider>
      <ThemeProviderWrapper>
        <UserMainPageContent />
      </ThemeProviderWrapper>
    </ThemeModeProvider>
  );
}

export default UserMainPage;
